import { DateBox, SelectBox, TextBox } from 'devextreme-react';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Card, CardBody } from 'reactstrap';
import Breadcrumb from '../../components/common/breadcrumb';
import api from '../../services/api-configuration-v3';

const HalTest = () => {
    const [inputMode, setInputMode] = useState('form'); // 'form' or 'json'
    const [messageType, setMessageType] = useState('OC');
    const [loading, setLoading] = useState(false);
    const [jsonInput, setJsonInput] = useState('');
    const [response, setResponse] = useState(null);

    // OC message type fields
    const [formData, setFormData] = useState({
        datetime_event: moment().toISOString(),
        vin: '',
        order_number: '',
        order_sap: '',
        origin_cedi: '',
        make: '',
        model: '',
        dealer_code: '',
        destination_city: '',
        loading_date: moment().format('YYYY-MM-DD'),
        range_time_scheduled: '',
        loading_dock: ''
    });

    const messageTypeOptions = [
        { value: 'OC', label: 'OC' },
        { value: 'COUT', label: 'COUT' }
    ];

    const getDefaultJson = () => {
        if (messageType === 'COUT') {
            return JSON.stringify({
                message_type: "COUT",
                datetime_event: moment().toISOString(),
                vin: "WAUZZZ8V0JA000001",
                origin_cedi: "IZ1"
            }, null, 2);
        }
        return JSON.stringify({
            message_type: "OC",
            datetime_event: moment().toISOString(),
            vin: "WAUZZZ8V0JA000001",
            order_number: 123456,
            order_sap: 987654,
            origin_cedi: "IZ1",
            make: "PEUGEOT",
            model: "2008",
            dealer_code: "00000313",
            destination_city: "İstanbul",
            loading_date: moment().format('YYYY-MM-DD'),
            range_time_scheduled: "08:00-12:00",
            loading_dock: "1"
        }, null, 2);
    };

    useEffect(() => {
        if (inputMode === 'json') {
            setJsonInput(getDefaultJson());
        } else {
            // Form modunda message type değiştiğinde formData'yı sıfırla
            setFormData(getDefaultFormData());
        }
    }, [inputMode, messageType]);

    const getDefaultFormData = () => {
        if (messageType === 'COUT') {
            return {
                datetime_event: moment().toISOString(),
                vin: '',
                origin_cedi: ''
            };
        }
        return {
            datetime_event: moment().toISOString(),
            vin: '',
            order_number: '',
            order_sap: '',
            origin_cedi: '',
            make: '',
            model: '',
            dealer_code: '',
            destination_city: '',
            loading_date: moment().format('YYYY-MM-DD'),
            range_time_scheduled: '',
            loading_dock: ''
        };
    };

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleReset = () => {
        if (inputMode === 'form') {
            setFormData(getDefaultFormData());
        } else {
            setJsonInput(getDefaultJson());
        }
        setResponse(null);
        toast.info('Form sıfırlandı');
    };

    const handleSend = async () => {
        try {
            setLoading(true);

            let body;

            if (inputMode === 'json') {
                try {
                    body = JSON.parse(jsonInput);
                } catch (error) {
                    toast.error('Geçersiz JSON formatı');
                    return;
                }
            } else {
                body = {
                    message_type: messageType,
                    ...formData
                };

                // Convert datetime_event to ISO format if it's a Date object
                if (body.datetime_event instanceof Date) {
                    body.datetime_event = moment(body.datetime_event).toISOString();
                }

                // Convert order_number and order_sap to numbers if they're strings
                if (body.order_number) {
                    body.order_number = parseInt(body.order_number) || 0;
                }
                if (body.order_sap) {
                    body.order_sap = parseInt(body.order_sap) || 0;
                }
            }

            const response = await api.post('/hal/message', body);

            if (response.data) {
                setResponse(response.data);
                toast.success('İstek başarıyla gönderildi');
                console.log('Response:', response.data);
            } else {
                setResponse(null);
                toast.error('Yanıt alınamadı');
            }
        } catch (error) {
            // API interceptor error'u transform ediyor, bu yüzden error.data kullanıyoruz
            // error.originalError.response.data ile orijinal response'a da erişebiliriz
            let responseData = null;

            // Önce interceptor'dan gelen transformed data'yı kontrol et
            if (error.data) {
                responseData = error.data;
            }
            // Eğer yoksa, orijinal error.response.data'yı kontrol et
            else if (error.originalError?.response?.data) {
                responseData = error.originalError.response.data;
            }
            // Son olarak direkt error.response.data'yı kontrol et
            else if (error.response?.data) {
                responseData = error.response.data;
            }

            if (responseData) {
                // Response'u olduğu gibi set et
                setResponse(responseData);

                // Toast mesajı için error array'ini veya detail'i kullan
                let errorMessage = '';
                if (responseData.detail) {
                    errorMessage = responseData.detail;
                } else if (Array.isArray(responseData.error)) {
                    errorMessage = responseData.error.join(', ');
                } else if (responseData.error) {
                    errorMessage = responseData.error;
                } else if (error.message) {
                    errorMessage = error.message;
                } else {
                    errorMessage = 'İstek gönderilirken hata oluştu';
                }
                toast.error(errorMessage);
            } else {
                setResponse({
                    error: [error.message || 'İstek gönderilirken hata oluştu'],
                    status_code: error.status || error.response?.status || 0
                });
                toast.error(error.message || 'İstek gönderilirken hata oluştu');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Breadcrumb current="HAL TEST" />
            <div className="p-2 bg-light min-vh-100">
                <Card className="mb-0 border shadow-sm">
                    <CardBody className="p-3">
                        <div style={{ marginBottom: '12px', display: 'flex', gap: '8px', alignItems: 'center' }}>
                            <SelectBox
                                dataSource={messageTypeOptions}
                                displayExpr="label"
                                valueExpr="value"
                                value={messageType}
                                onValueChange={(value) => setMessageType(value)}
                                width="150px"
                                height={30}
                            />
                            <div style={{ display: 'flex', gap: '4px', marginLeft: 'auto' }}>
                                <Button
                                    size="sm"
                                    color={inputMode === 'form' ? 'primary' : 'secondary'}
                                    onClick={() => setInputMode('form')}
                                    style={{ padding: '4px 12px', fontSize: '12px', height: '30px' }}
                                >
                                    Form
                                </Button>
                                <Button
                                    size="sm"
                                    color={inputMode === 'json' ? 'primary' : 'secondary'}
                                    onClick={() => setInputMode('json')}
                                    style={{ padding: '4px 12px', fontSize: '12px', height: '30px' }}
                                >
                                    JSON
                                </Button>
                            </div>
                        </div>

                        {inputMode === 'form' && messageType === 'OC' && (
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '8px' }}>
                                <div>
                                    <div style={{ fontSize: '11px', color: '#666', marginBottom: '2px' }}>Datetime Event</div>
                                    <DateBox
                                        type="datetime"
                                        displayFormat="dd.MM.yyyy HH:mm:ss"
                                        value={formData.datetime_event ? new Date(formData.datetime_event) : null}
                                        onValueChange={(value) => handleInputChange('datetime_event', value ? moment(value).toISOString() : '')}
                                        width="100%"
                                        height={30}
                                        showClearButton={true}
                                    />
                                </div>
                                <div>
                                    <div style={{ fontSize: '11px', color: '#666', marginBottom: '2px' }}>VIN</div>
                                    <TextBox
                                        value={formData.vin}
                                        onValueChange={(value) => handleInputChange('vin', value)}
                                        placeholder="WAUZZZ8V0JA000001"
                                        width="100%"
                                        height={30}
                                        showClearButton={true}
                                    />
                                </div>
                                <div>
                                    <div style={{ fontSize: '11px', color: '#666', marginBottom: '2px' }}>Order Number</div>
                                    <TextBox
                                        value={formData.order_number}
                                        onValueChange={(value) => handleInputChange('order_number', value)}
                                        placeholder="123456"
                                        width="100%"
                                        height={30}
                                        showClearButton={true}
                                    />
                                </div>
                                <div>
                                    <div style={{ fontSize: '11px', color: '#666', marginBottom: '2px' }}>Order SAP</div>
                                    <TextBox
                                        value={formData.order_sap}
                                        onValueChange={(value) => handleInputChange('order_sap', value)}
                                        placeholder="987654"
                                        width="100%"
                                        height={30}
                                        showClearButton={true}
                                    />
                                </div>
                                <div>
                                    <div style={{ fontSize: '11px', color: '#666', marginBottom: '2px' }}>Origin CEDI</div>
                                    <TextBox
                                        value={formData.origin_cedi}
                                        onValueChange={(value) => handleInputChange('origin_cedi', value)}
                                        placeholder="IZ1"
                                        width="100%"
                                        height={30}
                                        showClearButton={true}
                                    />
                                </div>
                                <div>
                                    <div style={{ fontSize: '11px', color: '#666', marginBottom: '2px' }}>Make</div>
                                    <TextBox
                                        value={formData.make}
                                        onValueChange={(value) => handleInputChange('make', value)}
                                        placeholder="PEUGEOT"
                                        width="100%"
                                        height={30}
                                        showClearButton={true}
                                    />
                                </div>
                                <div>
                                    <div style={{ fontSize: '11px', color: '#666', marginBottom: '2px' }}>Model</div>
                                    <TextBox
                                        value={formData.model}
                                        onValueChange={(value) => handleInputChange('model', value)}
                                        placeholder="2008"
                                        width="100%"
                                        height={30}
                                        showClearButton={true}
                                    />
                                </div>
                                <div>
                                    <div style={{ fontSize: '11px', color: '#666', marginBottom: '2px' }}>Dealer Code</div>
                                    <TextBox
                                        value={formData.dealer_code}
                                        onValueChange={(value) => handleInputChange('dealer_code', value)}
                                        placeholder="00000313"
                                        width="100%"
                                        height={30}
                                        showClearButton={true}
                                    />
                                </div>
                                <div>
                                    <div style={{ fontSize: '11px', color: '#666', marginBottom: '2px' }}>Destination City</div>
                                    <TextBox
                                        value={formData.destination_city}
                                        onValueChange={(value) => handleInputChange('destination_city', value)}
                                        placeholder="İstanbul"
                                        width="100%"
                                        height={30}
                                        showClearButton={true}
                                    />
                                </div>
                                <div>
                                    <div style={{ fontSize: '11px', color: '#666', marginBottom: '2px' }}>Loading Date</div>
                                    <DateBox
                                        type="date"
                                        displayFormat="dd.MM.yyyy"
                                        value={formData.loading_date ? new Date(formData.loading_date) : null}
                                        onValueChange={(value) => handleInputChange('loading_date', value ? moment(value).format('YYYY-MM-DD') : '')}
                                        width="100%"
                                        height={30}
                                        showClearButton={true}
                                    />
                                </div>
                                <div>
                                    <div style={{ fontSize: '11px', color: '#666', marginBottom: '2px' }}>Range Time Scheduled</div>
                                    <TextBox
                                        value={formData.range_time_scheduled}
                                        onValueChange={(value) => handleInputChange('range_time_scheduled', value)}
                                        placeholder="08:00-12:00"
                                        width="100%"
                                        height={30}
                                        showClearButton={true}
                                    />
                                </div>
                                <div>
                                    <div style={{ fontSize: '11px', color: '#666', marginBottom: '2px' }}>Loading Dock</div>
                                    <TextBox
                                        value={formData.loading_dock}
                                        onValueChange={(value) => handleInputChange('loading_dock', value)}
                                        placeholder="1"
                                        width="100%"
                                        height={30}
                                        showClearButton={true}
                                    />
                                </div>
                            </div>
                        )}

                        {inputMode === 'form' && messageType === 'COUT' && (
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '8px' }}>
                                <div>
                                    <div style={{ fontSize: '11px', color: '#666', marginBottom: '2px' }}>Datetime Event</div>
                                    <DateBox
                                        type="datetime"
                                        displayFormat="dd.MM.yyyy HH:mm:ss"
                                        value={formData.datetime_event ? new Date(formData.datetime_event) : null}
                                        onValueChange={(value) => handleInputChange('datetime_event', value ? moment(value).toISOString() : '')}
                                        width="100%"
                                        height={30}
                                        showClearButton={true}
                                    />
                                </div>
                                <div>
                                    <div style={{ fontSize: '11px', color: '#666', marginBottom: '2px' }}>VIN</div>
                                    <TextBox
                                        value={formData.vin}
                                        onValueChange={(value) => handleInputChange('vin', value)}
                                        placeholder="WAUZZZ8V0JA000001"
                                        width="100%"
                                        height={30}
                                        showClearButton={true}
                                    />
                                </div>
                                <div>
                                    <div style={{ fontSize: '11px', color: '#666', marginBottom: '2px' }}>Origin CEDI</div>
                                    <TextBox
                                        value={formData.origin_cedi}
                                        onValueChange={(value) => handleInputChange('origin_cedi', value)}
                                        placeholder="IZ1"
                                        width="100%"
                                        height={30}
                                        showClearButton={true}
                                    />
                                </div>
                            </div>
                        )}

                        {inputMode === 'json' && (
                            <div>
                                <div style={{ fontSize: '11px', color: '#666', marginBottom: '4px' }}>JSON</div>
                                <textarea
                                    value={jsonInput}
                                    onChange={(e) => setJsonInput(e.target.value)}
                                    style={{
                                        width: '100%',
                                        minHeight: '400px',
                                        fontFamily: 'monospace',
                                        fontSize: '12px',
                                        padding: '8px',
                                        border: '1px solid #ddd',
                                        borderRadius: '4px',
                                        resize: 'vertical'
                                    }}
                                    placeholder="JSON yapıştırın..."
                                />
                            </div>
                        )}

                        <div style={{ marginTop: '12px', textAlign: 'right', display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                            <Button
                                color="secondary"
                                onClick={handleReset}
                                disabled={loading}
                                size="sm"
                                style={{ padding: '5px 16px', fontSize: '12px', height: '30px' }}
                            >
                                <i className="fa fa-refresh mr-1"></i>
                                Reset
                            </Button>
                            <Button
                                color="primary"
                                onClick={handleSend}
                                disabled={loading}
                                size="sm"
                                style={{ padding: '5px 16px', fontSize: '12px', height: '30px' }}
                            >
                                {loading ? (
                                    <>
                                        <i className="fa fa-spinner fa-spin mr-1"></i>
                                        Gönderiliyor...
                                    </>
                                ) : (
                                    <>
                                        <i className="fa fa-paper-plane mr-1"></i>
                                        Gönder
                                    </>
                                )}
                            </Button>
                        </div>

                        {response && (
                            <div style={{ marginTop: '16px', padding: '12px', backgroundColor: '#f8f9fa', borderRadius: '4px', border: '1px solid #dee2e6' }}>
                                <div style={{ fontSize: '11px', color: '#666', marginBottom: '6px', fontWeight: '500' }}>
                                    Response Body
                                </div>
                                <pre style={{
                                    margin: 0,
                                    padding: '8px',
                                    backgroundColor: '#fff',
                                    border: '1px solid #ddd',
                                    borderRadius: '4px',
                                    fontSize: '12px',
                                    fontFamily: 'monospace',
                                    maxHeight: '400px',
                                    overflow: 'auto',
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word'
                                }}>
                                    {JSON.stringify(response, null, 2)}
                                </pre>
                            </div>
                        )}
                    </CardBody>
                </Card>
            </div>
        </>
    );
};

export default HalTest;

